import React from 'react';
import { TagsTable } from './TagsTable';
import WelcomeBannerHome from '../../Components/home/WelcomeBannerHome';
import SideBar from '../../Components/home/SideBar';
import { CondorStandardTags } from '../../Components/manage-tags/CondorStandardTags';
import CondorSpinner from '../../Components/CondorSpinner';
import { useQuery } from '@tanstack/react-query';
import { getTagByName, Tag } from '../../services/TagsService';
import { useApiClient } from '../../hooks/useApiClient';
const getStandardTag = async (...names: string[]): Promise<Tag | null> => {
  for (const name of names) {
    try {
      const tag = await getTagByName(name);
      if (tag?.tagId) return tag;
    } catch (error) {
      console.error(`Error fetching tag ${name}:`, error);
    }
  }
  return null;
};

export const ManageTagsPage = () => {
  const { token } = useApiClient();
  const { data: phase2Data, isPending: phase2Loading } = useQuery({
    queryKey: ['phase2Tag'],
    queryFn: async () => getStandardTag('phase-2', 'purple'),
    enabled: !!token,
  });

  const { data: phase3Data, isPending: phase3Loading } = useQuery({
    queryKey: ['phase3Tag'],
    queryFn: async () => getStandardTag('phase-3', 'yellow'),
    enabled: !!token,
  });

  const standardTags = [
    { tagId: phase2Data?.tagId ?? '', tagName: phase2Data?.tagName ?? '' },
    { tagId: phase3Data?.tagId ?? '', tagName: phase3Data?.tagName ?? '' },
  ];

  return (
    <div style={{ paddingBottom: '5%' }}>
      <WelcomeBannerHome subtitle="Let's manage some tags and stuff" />
      <div style={{ display: 'flex' }}>
        <div style={{ flexBasis: '20%' }}>
          <SideBar />
        </div>
        <div style={{ flexBasis: '80%' }}>
          {phase2Loading || phase3Loading ? (
            <CondorSpinner />
          ) : (
            <>
              <CondorStandardTags standardTags={standardTags} />
              <TagsTable standardTags={standardTags} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
